import { useQuery } from "@tanstack/react-query";
import { Spin } from "antd";
import { IoIosArrowForward } from "react-icons/io";
import { useIntl } from "react-intl";
import { getSubscriptionPlans } from "../../../../network/onboarding";
import PriceCard from "../../../onboarding/PriceCard";

type Props = { setShowPricingPlan: any; SalonData: any };

const PricingPlan = ({ setShowPricingPlan, SalonData }: Props) => {
  const intl = useIntl();
  const {
    data: plans,
    isLoading,
    isError,
  } = useQuery(["SubscriptionPlans"], () => getSubscriptionPlans());
  console.log(plans);

  return (
    <div className="flex flex-col">
      <div
        className="flex items-center gap-2 mb-6 cursor-pointer"
        onClick={() => setShowPricingPlan(false)}
      >
        <IoIosArrowForward className="text-[#75757E] flex items-center" />
        <h5 className="text-sm text-[#75757E] font-semibold">
          {intl.formatMessage({ id: "back" })}
        </h5>
      </div>
      <div className="flex flex-col items-center justify-center gap-4 mb-8">
        <h4 className="text-[#020418] text-xl font-semibold">
          {intl.formatMessage({ id: "price_plan_update_title" })}
        </h4>
        <p className="text-sm text-[#75757E] max-w-[300px] text-center">
          {intl.formatMessage({ id: "price_plan_update_description" })}
        </p>
      </div>
      <div className="flex justify-center gap-4">
        {isLoading ? (
          <Spin className="flex items-center justify-center" size="large" />
        ) : (
          plans?.data?.map((e: any) => {
            // Filtering non-commission features
            const feats = e?.features?.filter(
              (feature: any) =>
                feature?.key !== "commission_new_online_bookings" &&
                feature?.key !== "commission_recurring_online_bookings"
            );

            // Filtering commission features
            const commissions = e?.features?.filter(
              (feature: any) =>
                feature?.key === "commission_new_online_bookings" ||
                feature?.key === "commission_recurring_online_bookings"
            );

            return (
              <PriceCard
                title={e.title}
                name={e.name}
                feats={feats}
                id={e.id}
                myPlanId={SalonData?.data?.subscription_plan?.plan?.id}
                commissions={commissions}
                price={e.price}
                recommended={false}
              />
            );
          })
        )}
      </div>
    </div>
  );
};

export default PricingPlan;
